// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { ImgTournament } from '@/vue3/api/models';

export const useEuropeTourService = () => {
    // hooks
    const axios = useAxios();
    const { apiUrl } = useStore().state;

    // methods
    const populateEuropeTourData = async (
        tournamentId: number,
    ): Promise<ImgTournament[]> => {
        const res = await axios.post(
            `${apiUrl}/europetour/tournament/${tournamentId}/populate`,
            null,
        );
        return res.data;
    };

    const getEurpeTourCoursesData = async (): Promise<any> => {
        const res = await axios.get(`${apiUrl}/europetour/courses`);
        return res.data;
    };

    const getEurpeTourEventData = async (): Promise<any> => {
        const res = await axios.get(`${apiUrl}/europetour/events/completed`);
        return res.data;
    };

    const mapCourseSchemaEuroCourseId = async (
        courseId: any,
        eventId: any,
    ): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/europetour/course/${courseId}/eurocourse/${eventId}`,
            null,
        );
        return res.data;
    };

    const startHarvester = async (tourId: any): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/europetour/harvestor/start/${tourId}`,
            null,
        );
        return res.data;
    };

    const stopHarvester = async (): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/europetour/harvestor/stop`,
            null,
        );
        return res.data;
    };

    const getLatestBallPosition = async (id: number): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/europetour/tournament/course/${id}/ball`,
        );
        return res.data;
    };

    const getInProgressEvents = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/europetour/course/${id}/events`);
        return res.data;
    };
    const getAllShotData = async (id: number): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/europetour/tournament/course/${id}/allball`,
        );
        return res.data;
    };

    return {
        getAllShotData,
        stopHarvester,
        startHarvester,
        getInProgressEvents,
        getLatestBallPosition,
        populateEuropeTourData,
        getEurpeTourCoursesData,
        getEurpeTourEventData,
        mapCourseSchemaEuroCourseId,
    };
};
